import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import debateMindLogo from "../assets/debate-mind-ai.png";
import "../styles/User_Login.css";
import axios from 'axios';

const UserLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [emailOrUsername, setEmailOrUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [adminAccessMsg, setAdminAccessMsg] = useState("");

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      setIsLoggedIn(true);
    }
  }, []);

  useEffect(() => {
    if (location.state?.fromRegistration) {
      setSuccessMsg("Registered successfully! Please log in.");
      const timer = setTimeout(() => setSuccessMsg(""), 5000);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_API}/talk-show-login/`, {
        // const response = await axios.post("http://192.168.1.10:8000/api/talk-show-web-login/", {
        email: emailOrUsername,
        userPassword: password,
      });
      const response_data = response.data;
      
      // Backend returns user data in userDto array
      if (!response_data.userDto || response_data.userDto.length === 0) {
        throw new Error('No user data in response');
      }
      
      const user = response_data.userDto[0]; // Extract first user object from array
      const userId = user.id; // Get the user ID
      
      // Save user details to localStorage
      localStorage.setItem("userId", String(userId));
      localStorage.setItem("user_id", String(userId));
      localStorage.setItem("userName", user.userName || user.username);
      localStorage.setItem("email", user.email);
      localStorage.setItem("user_role", user.user_role);
      localStorage.setItem("accessToken", response_data.accessToken); // Store JWT token
      
      console.log('Login successful! userId stored:', userId);

      setSuccessMsg("Login successful!");
      setIsLoggedIn(true);
      navigate("/home");

    } catch (error) {
      if (error.response && error.response.data && error.response.data.detail) {
        setErrorMsg(error.response.data.detail);
      } else {
        setErrorMsg("Login failed. Please check your credentials.");
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("userId");
    localStorage.removeItem("user_id");
    localStorage.removeItem("userName");
    localStorage.removeItem("email");
    localStorage.removeItem("user_role");
    localStorage.removeItem("AuthToken");
    localStorage.removeItem("auth");
    setIsLoggedIn(false);
    setSuccessMsg("You have been logged out successfully.");
    setTimeout(() => {
      setSuccessMsg("");
      navigate("/user-login");
    }, 2000);
  };

  const handleAdminPanel = () => {
    const userRole = localStorage.getItem("user_role");

    if (userRole === "Admin") {
      navigate("/admin-panel");
    } else {
      setAdminAccessMsg("You are not an admin. Access denied.");
      setTimeout(() => setAdminAccessMsg(""), 5000);
    }
  };

  const userRole = localStorage.getItem("user_role");

  if (isLoggedIn) {
    return (
      <div className="form-wrapper">
        <div className="form-header">
          <img src={debateMindLogo} className="logo" alt="Debate Mind Logo" />
        </div>

        <h2 className="form-title">You are already logged in</h2>

        <div className="logged-in-message">
          <p>
            You're currently logged in as:{" "}
            <strong style={{ color: '#0D6EFD' }}>{localStorage.getItem("username")}</strong>
          </p>
          <p>Would you like to log out or go to the home page?</p>
        </div>

        {successMsg && <p className="success-message">{successMsg}</p>}
        {adminAccessMsg && <p className="error-message">{adminAccessMsg}</p>}

        <div className="button-group">
          <button onClick={() => navigate("/home")} className="submit-button1" style={{ backgroundColor: '#0D6EFD' }}>
            Go to Home
          </button>
          <button onClick={handleLogout} className="logout-button" style={{ backgroundColor: '#030213' }}>
            Logout
          </button>
          {/* <button onClick={handleAdminPanel} className="admin-panel-button">
            Admin Panel
          </button> */}
        </div>
      </div>
    );
  }

  return (
    <div className="form-wrapper">
      <div className="form-header">
        <img src={debateMindLogo} className="logo" alt="Debate Mind Logo" />
      </div>

      <h2 className="form-title">User Sign In</h2>

      <form className="login-form" onSubmit={handleSubmit}>
        <label className="form-label">Email or Username<span style={{ color: "red" }}>*</span></label>
        <input
          type="text"
          className="form-input"
          placeholder="Email or Username"
          value={emailOrUsername}
          onChange={(e) => setEmailOrUsername(e.target.value)}
          required
        />

        <label className="form-label">Password<span style={{ color: "red" }}>*</span></label>
        <input
          type="password"
          className="form-input"
          placeholder="Enter Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {errorMsg && <p className="error-message">{errorMsg}</p>}
        {successMsg && <p className="success-message">{successMsg}</p>}
        {adminAccessMsg && <p className="error-message">{adminAccessMsg}</p>}

        <button type="submit" className="submit-button1">
          Sign In
        </button>

        
        {/* <div className="admin-login-text" style={{ marginTop: "15px", textAlign: "center" }}>
          <button
            onClick={() => navigate("/login")}
            style={{
              background: "none",
              border: "none",
              color: "#0D6EFD",
              cursor: "pointer",
              textDecoration: "underline",
              fontSize: "14px",
              fontWeight: "500",
              padding: 0
            }}
          >
            Admin Login
          </button>
        </div> */}

      </form>

      {/* Always show Admin Panel button */}
      {/* <div className="admin-panel-section">
        <button onClick={handleAdminPanel} className="admin-panel-button">
          Admin Panel
        </button>
      </div> */}
    </div>
  );
};

export default UserLogin;